<template >
  <div :class="this.$route.path == '/workflow/backlog' ? 'bg-light' : ''" style="min-height: 100%;">
    <!-- Loading Overlay - Troca de Módulo -->
    <v-overlay :value="trocandoModulo" z-index="9999">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <div class="mt-4 white--text text-h6">
          Trocando de módulo...
        </div>
        <div class="mt-2 white--text text-caption">
          Carregando menus e permissões
        </div>
      </div>
    </v-overlay>

    <dashboard-header-component @gerenciarMenu="gerenciadorDeEstadoDoMenu" />

    <v-navigation-drawer
      v-model="menuEstaAberto"
      app
      temporary
      :class="`mt-14 no-padding`"
    >
      <menu-component @emitRecolherMenuSidebar="recolherMenu()" class="menu-wrapper" v-if="menuEstaAberto" />
            
    </v-navigation-drawer>

    <v-container fluid>

      <v-row no-gutters>
          

        <v-col class="body-wrapper">
          <router-view />

          <FormPesquisaSatisfacaoComponent />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DashboardHeaderComponent from "@/common/sgp-components/DashboardHeaderComponent.vue";
import MenuComponent from "@/modules/app/menu/components/MenuComponent.vue";
// import FormPesquisaSatisfacaoComponent from '@/modules/sgp/pco-pesquisas/components/FormPesquisaSatisfacaoComponent.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    DashboardHeaderComponent,
    MenuComponent,
    // FormPesquisaSatisfacaoComponent
  },

  name: "MainLayout",

  data() {
    return {
      menuEstaAberto: false,
      auth: false,
    };
  },

  computed: {
    ...mapGetters('ctrlModulos', ['trocandoModulo'])
  },

  methods: {
    ...mapActions('login', ['usuarioEstaLogado']),
    ...mapActions('ctrlModulos', ['buscarModulos']),
    gerenciadorDeEstadoDoMenu() {
      this.menuEstaAberto = !this.menuEstaAberto;
    },
    recolherMenu () {
      this.menuEstaAberto = false
    },
    async validarModuloAtivo() {
      const moduloAtivo = localStorage.getItem('moduloAtivo');
      const rotaRequerModulo = this.$route.matched.some(r => r.meta.requiresModule);
      
      if (rotaRequerModulo && moduloAtivo) {
        await this.buscarModulos();
        
        const moduloValido = this.$store.state.ctrlModulos.modulos.find(
          m => m.id == moduloAtivo && m.has_access
        );
        
        if (!moduloValido) {
          localStorage.removeItem('moduloAtivo');
          this.$router.push('/selecionar-modulo');
        }
      }
    }
  },
  async created() {
    await this.usuarioEstaLogado();
    await this.validarModuloAtivo();
  },

  watch: {
    '$route': {
      handler () {
        this.menuEstaAberto = false
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  padding: 0 0 0 5px;
}
</style>